import { AdminLayout } from "@opendash/core/dist/components/AdminLayout";
import "easymde/dist/easymde.min.css";
import Parse from "parse"; // Stelle sicher, dass 'parse' korrekt importiert ist.
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "../../../../libs/router/dist";
import md from "../DokuStartseite";
import { Document } from "../js/parsegenerated";
import ReadOnlyEditor from "./ReadOnlyEditor";

// Hier wird der Inhalt der Dokumente aus Parse abgerufen
async function fetchDocumentContent(id: string): Promise<Document> {
  const query = new Parse.Query(Document); // Dokumente aus der 'Document' Tabelle abfragen / Objects in Arrays speichern! Dynamisch besser

  try {
    const results = await query.get(id);
    // Abrufen der Dokumente
    return results;
  } catch (error) {
    console.error("Fehler beim Abrufen des Inhalts:", error); // Detailierte Fehlerausgabe
    throw new Error(
      `Dokument konnte nicht geladen werden. Fehler: ${error.message}`
    );
  }
}

const DokuPage = () => {
  const [markdownContent, setMarkdownContent] = useState<string>(""); // Array für mehrere Inhalte
  const location = useLocation();
  const isOverviewPage = location.pathname.startsWith(
    "/documentation/overview/*"
  );
  const { id } = useParams();

  useEffect(() => {
    async function getDocumentContent() {
      try {
        const document = await fetchDocumentContent(id);
        setMarkdownContent(document.get("content"));
      } catch (e) {
        console.error("Fehler:", e);
      }
    }
    if (id && !isOverviewPage) {
      getDocumentContent();
    }
  }, [id, location.pathname]);

  return (
    <AdminLayout>
      <div className="od-page-main">
        {isOverviewPage ? (
          <ReadOnlyEditor value={md} />
        ) : (
          <ReadOnlyEditor value={markdownContent} />
        )}
      </div>
    </AdminLayout>
  );
};

export default DokuPage;
